import { EpimsBaseEntityDto } from './epim-base.dto';

export class CorrespondenceRegisterDto extends EpimsBaseEntityDto {
  IssuingOrganization: string;
  ReceivedDate: Date;
  Receiver: string;
  Sender: string;
  DateWritten: Date;
  IssuedCategoryId: string;
  CorrespondenceTeamId: string;
  BusinessFocalPointEmail: string;
  ActionTaken: string;
  ReceivedByPerson: string;
  ExpectedCompletedDate: Date;
  ActionReviewer: string;
  OrganizationCorrespondenceNo: string;

  Address: string;
  PhoneNo: string;
  Email: string;
  IssueSummary: string;
  DeliveryDate: Date;


  Requestor: string;


  CorrespondenceTitle: string;
  BusinessFocalPoint: string;
  LevelOfCriticality: string;



  Issue: string;
  DateOnLetter: Date;
  DateToCompany: Date;
  DateToLands: Date;
  RegisterId: string;
  RequestCategoryId: string;
  ActionPlanned: string;

  Status: string;
  ActionDate: Date;
  Traffic: string;
  Remarks: string;
  DateClosed: Date;




  DocumentUrl: string;
  CloseOutRemark: string;
  CommunityId: string;
  ClaimantName: string;
  ReOpeningDate: Date;
  ReOpeningRemarks: string;
  DocumentId: string;

  CorrespondenceCompanyId: string;
}
